import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadIpmaCisBarCreator } from 'store/actionsCreators';
import { useTranslation } from 'react-i18next';
import { useSubRoutes, useExactRedirect, usePermissionTabs } from 'hooks';
import { globalPropTypes } from 'helpers';
import { Tabs, Alerts } from 'components';
import CisHeader from 'components/CisHeader/CisHeader';

const breadcrumbs = [
  {
    title: 'navigation.breadcrumbs.ma.cis',
    url: '/ma/cis',
  },
];

const initialTabs = [
  {
    title: 'navigation.tabs.user.cis.myCertificationBody',
    path: '/ma/cis/certification-bodies/details',
    key: 'certificationBody',
  },
  {
    title: 'navigation.tabs.user.cis.certificateHolders',
    path: '/ma/cis/certificate-holders',
    key: 'certificateHolders',
  },
  {
    title: 'navigation.tabs.user.cis.certificates',
    path: '/ma/cis/certificates',
    key: 'certificates',
  },
  {
    title: 'navigation.tabs.user.cis.forecasts',
    path: '/ma/cis/forecasts',
    key: 'forecasts',
  },
  {
    title: 'navigation.tabs.user.cis.reports',
    path: '/ma/cis/reports',
    key: 'certificationReports',
  },
  {
    title: 'navigation.tabs.user.cis.assessors',
    path: '/ma/cis/assessors',
    key: 'assessors',
  },
  {
    title: 'navigation.tabs.user.cis.unknownImports',
    path: '/ma/cis/unknown-imports',
    key: 'unknownImports',
  },
  {
    title: 'navigation.tabs.user.cis.changeRequests',
    path: '/ma/cis/change-requests',
    key: 'changeRequests',
  }
];

const Cis = ({ routes, loadBar, bar, userPermissions }) => {
  const { t } = useTranslation();

  const [renderSubRoutes] = useSubRoutes(routes);
  const [tabs, firstTabPath] = usePermissionTabs(initialTabs, routes, userPermissions, bar);
  const [renderExactRedirect] = useExactRedirect('/ma/cis', firstTabPath);

  return (
    <>
      <CisHeader
        breadcrumbs={breadcrumbs}
        title={t('page.ma.cis.title')}
        renderActions={() => <div id="ma-cis-buttons-portal"></div>}
      />
      <Tabs disableCounter={true} items={tabs} />
      <Alerts type="cis" />
      {renderExactRedirect()}
      {renderSubRoutes()}
    </>
  );
};

Cis.propTypes = {
  routes: PropTypes.arrayOf(globalPropTypes.RoutePropTypes),
  userPermissions: globalPropTypes.UserPermissions.isRequired,
  bar: PropTypes.shape({
    cetificateHolders: PropTypes.number,
    certificates: PropTypes.number,
  }).isRequired,
};

Cis.defaultProps = {
  routes: [],
};

const mapStateToProps = ({ ma, user }) => ({
  bar: ma.cis.bar,
  userPermissions: user.userPermissions,
});

const mapDispatchToProps = (dispatch) => ({
  loadBar: () => dispatch(loadIpmaCisBarCreator()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Cis);
